import Unit from '@leverege/unit';
function createFor(type) {
  function normalize(obj, opts) {
    let {
      toUnit: unit
    } = opts || {};
    if (!unit) {
      const unitTypes = Unit.getUnitsOfType(type);
      unit = unitTypes.length > 0 ? unitTypes[0].symbol : null;
    }
    if (obj?.unit && unit) {
      return Unit.convert(obj.value, obj.unit, unit);
    }
    return obj?.value || obj;
  }
  function denormalize(value, opts) {
    let {
      toUnit: unit
    } = opts || {};
    if (!unit) {
      const unitTypes = Unit.getUnitsOfType(type);
      unit = unitTypes.length > 0 ? unitTypes[0].symbol : null;
    }
    return {
      type,
      unit,
      value
    };
  }
  return {
    normalize,
    denormalize
  };
}
export default {
  createFor
};